import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { CustomerAgreementStateType } from '../../modules/user-agreements/agreement';
export const walletAgreementCode = 'WalletContract';

const getAgreementState = (state: AppState) => state.agreementState;

export const getAgreements = createSelector(getAgreementState, state => {
	return state.agreements;
});

export const getUserAgreements = createSelector(getAgreementState, state => {
	return state.agreements.filter(
		a =>
			a.codeName != walletAgreementCode &&
			(a.status === CustomerAgreementStateType.Active || a.status === CustomerAgreementStateType.Inactive)
	);
});

export const getUserUnseenAgreements = createSelector(getAgreementState, state => {
	return state.agreements.filter(
		a => a.codeName != walletAgreementCode && a.status === CustomerAgreementStateType.Unseen
	);
});

export const getAgreementLoading = createSelector(getAgreementState, state => {
	return state.loading;
});

export const getAgreementById = (id: string) =>
	createSelector(getAgreements, agreements => agreements.find(t => t.id === id));

export const cautionAgreementStatus = createSelector(
	getAgreements,
	agreements =>
		agreements.find(a => a.codeName === 'CodalCautionTransaction')?.status ?? CustomerAgreementStateType.Unseen
);

export const baseMarketAgreementStatus = createSelector(
	getAgreements,
	agreements => agreements.find(a => a.codeName === 'BasicMarketRisk')?.status ?? CustomerAgreementStateType.Unseen
);
export const basicOptionRiskAgreementStatus = createSelector(
	getAgreements,
	agreements =>
		agreements.find(a => a.codeName === 'BasicOptionRisk-Orbis')?.status ?? CustomerAgreementStateType.Unseen
);

export const walletCardAgreement = createSelector(getAgreements, agreements =>
	agreements.find(a => a.codeName === 'WalletContract')
);

// get userRequiredAgreements(): AgreementsDto[] {
// 	if (this.agreementService.agreementsData)
//
// 	else return [];
// }
